import { Capacitor } from '@capacitor/core';
import { environment } from '../../../environments/environment';

/**
 * All hostnames where the Mock DevTools panel is enabled.
 * Add or remove entries here to control which environments expose the panel.
 */
const MOCK_DEVTOOLS_HOSTNAMES: readonly string[] = ['localhost', 'customers.dev.365dev.org'];

export function isMockDevToolsEnabled(): boolean {
  if (!environment.mockDevTools) return false;
  return MOCK_DEVTOOLS_HOSTNAMES.includes(window.location.hostname) || Capacitor.isNativePlatform();
}
